import { render, staticRenderFns } from "./FormCLient.vue?vue&type=template&id=679bf2f0&scoped=true&"
import script from "./FormCLient.vue?vue&type=script&lang=js&"
export * from "./FormCLient.vue?vue&type=script&lang=js&"
import style0 from "./FormCLient.vue?vue&type=style&index=0&id=679bf2f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679bf2f0",
  null
  
)

export default component.exports